import React, { useState } from "react";
import {
  Box,
  ButtonStyled,
  ThemeLoader,
} from "../../../../components/styled/Elements";
import CabinetsList from "./CabinetsList";
import FilesList from "./FilesList";
import ArchivesList from "./ArchivesList";
import { useTranslation } from "react-i18next";

const SearchResults = ({
  loading,
  cabinetsData,
  filesData,
  archivesData,
  activePage,
  setActivePage,
  perPage,
  totalCount,
  getCabinetsList,
  searchParams,
}) => {
  const { t } = useTranslation();
  const [expandedList, setExpandedList] = useState(null);
  const handleLoadMore = (listName) => {
    setExpandedList(listName);
  };
  return (
    <>
      {loading ? (
        <ThemeLoader />
      ) : (
        <Box>
          {/* Cabinets */}
          {/* <CabinetsList
            rowsData={
              expandedList === "cabinets"
                ? cabinetsData
                : cabinetsData.slice(0, 10)
            }
            activePage={activePage}
            setActivePage={setActivePage}
            perPage={perPage}
            totalCount={totalCount}
            getCabinetsList={getCabinetsList}
            searchParams={searchParams}
          />
          {cabinetsData.length > 10 && expandedList !== "cabinets" && (
            <Box className="d-flex justify-content-center">
              <ButtonStyled
                label={t("load_more")}
                onClick={() => handleLoadMore("cabinets")}
              />
            </Box>
          )} */}
          {/* Files */}
          {/* <FilesList
            rowsData={
              expandedList === "files" ? filesData : filesData.slice(0, 10)
            }
            activePage={activePage}
            setActivePage={setActivePage}
            perPage={perPage}
            totalCount={totalCount}
            getCabinetsList={getCabinetsList}
            searchParams={searchParams}
          />
          {filesData.length > 10 && expandedList !== "archives" && (
            <Box className="d-flex justify-content-center">
              <ButtonStyled
                label={t("load_more")}
                onClick={() => handleLoadMore("files")}
              />
            </Box>
          )} */}
          {/* Archives */}
          <ArchivesList
            rowsData={
              expandedList === "archives"
                ? archivesData
                : archivesData.slice(0, 10)
            }
            activePage={activePage}
            setActivePage={setActivePage}
            perPage={perPage}
            totalCount={totalCount}
            getCabinetsList={getCabinetsList}
            searchParams={searchParams}
          />
          {archivesData.length > 10 && expandedList !== "archives" && (
            <Box className="d-flex justify-content-center">
              <ButtonStyled
                label={t("load_more")}
                onClick={() => handleLoadMore("archives")}
              />
            </Box>
          )}
        </Box>
      )}
    </>
  );
};

export default SearchResults;
